import { render, staticRenderFns } from "./editTipologiaPagamento.vue?vue&type=template&id=3ee985bc&"
import script from "./editTipologiaPagamento.vue?vue&type=script&lang=js&"
export * from "./editTipologiaPagamento.vue?vue&type=script&lang=js&"
import style0 from "./editTipologiaPagamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VFileInput,VForm,VRow,VTextField})
